import SubTabs from 'components/sub-tabs';
import React from 'react';
import { useIntl } from 'react-intl';
import { SectionTab } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/types/section-tab.enum';

type Props = {
  intro?: React.ReactNode;
  actions?: React.ReactNode;
  utils?: React.ReactNode;
};

const SettingsSubTabs: React.FC<Props> = () => {
  const intl = useIntl();
  const PAGE_NAME_ID = 'orderFeed.ofdMySupplyPlan';

  return (
    <SubTabs
      tabs={[
        {
          label: intl.formatMessage({ id: `${PAGE_NAME_ID}.ordersLabel` }),
          value: SectionTab.ORDERS,
        },
        {
          label: intl.formatMessage({ id: `${PAGE_NAME_ID}.inputSettingsLabel` }),
          value: SectionTab.INPUT_SETTINGS,
        },
      ]}
    />
  );
};

export default React.memo(SettingsSubTabs);
